import { Button, OptionTile, SearchableDropdown, SingleSelect, TextField } from "@manifesthhqinc/ui-library";
import { TitleLarge, TitleMedium } from "../../../components/font";
import Footer from "../../../components/footer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import HeadingContainer from "../../../layout/heading-container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import { FormSectionContainer, OptionsContainer, QuestionContainer } from "../IRAForm.styles";
import { industryOptions, occupationOptions } from "../constants";

const IRAOpenForm = (props: ConfirmTransferScreenProps) => {
  const { isFutureMoney, onClickContinue, iraFormData, setIRAFormData, isButtonLoading } = props;
  if (!isFutureMoney) {
    onClickContinue();
  }
  const shouldContinue =
    iraFormData.investmentPriority &&
    iraFormData.downturnReaction &&
    iraFormData.employmentStatus &&
    (iraFormData.employmentStatus === "EMPLOYED" || iraFormData.employmentStatus === "SELF_EMPLOYED"
      ? iraFormData.employerName && iraFormData.occupation && iraFormData.industry
      : true);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="Futuremoney-open-form">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge>Next, Futuremoney requires this additional info to open your IRA</TitleLarge>
          </HeadingContainer>

          <FormSectionContainer>
            <QuestionContainer>
              <TitleMedium>1. How would you like to invest?</TitleMedium>
              <OptionsContainer>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.investmentPriority === "AVOID_LOSSES"}
                  onChange={() =>
                    setIRAFormData({
                      ...iraFormData,
                      investmentPriority: "AVOID_LOSSES",
                    })
                  }
                >
                  Minimize & avoid losses
                </OptionTile>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.investmentPriority === "BALANCE_RISK"}
                  onChange={() => setIRAFormData({ ...iraFormData, investmentPriority: "BALANCE_RISK" })}
                >
                  Balanced risk
                </OptionTile>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.investmentPriority === "MAXIMIZE_RETURNS"}
                  onChange={() => setIRAFormData({ ...iraFormData, investmentPriority: "MAXIMIZE_RETURNS" })}
                >
                  Maximize returns
                </OptionTile>
              </OptionsContainer>
            </QuestionContainer>
            <QuestionContainer>
              <TitleMedium>2. What would you do if there's a large drop in the stock market?</TitleMedium>
              <OptionsContainer>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.downturnReaction === "SELL"}
                  onChange={() => setIRAFormData({ ...iraFormData, downturnReaction: "SELL" })}
                >
                  Sell
                </OptionTile>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.downturnReaction === "HOLD"}
                  onChange={() => setIRAFormData({ ...iraFormData, downturnReaction: "HOLD" })}
                >
                  Hold
                </OptionTile>
                <OptionTile
                  appearance="secondary"
                  variant="radioButton"
                  isSelected={iraFormData.downturnReaction === "BUY"}
                  onChange={() => setIRAFormData({ ...iraFormData, downturnReaction: "BUY" })}
                >
                  Buy
                </OptionTile>
              </OptionsContainer>
            </QuestionContainer>
            <QuestionContainer>
              <TitleMedium>3. Employment</TitleMedium>
              <SingleSelect
                size={"large"}
                title="What's your current employment status?"
                placeholder="Select an option"
                options={[
                  { value: "EMPLOYED", label: "Employed" },
                  { value: "UNEMPLOYED", label: "Unemployed" },
                  { value: "RETIRED", label: "Retired" },
                  { value: "SELF_EMPLOYED", label: "Self-employed" },
                ]}
                value={iraFormData.employmentStatus}
                onValueChange={(value) => setIRAFormData({ ...iraFormData, employmentStatus: value })}
              />
              {(iraFormData.employmentStatus === "EMPLOYED" || iraFormData.employmentStatus === "SELF_EMPLOYED") && (
                <>
                  <TextField
                    title="What’s your current employer name?"
                    name="employer"
                    value={iraFormData.employerName}
                    onChange={(e) => setIRAFormData({ ...iraFormData, employerName: e.target.value || "" })}
                    size={"large"}
                  />
                  <SearchableDropdown
                    options={industryOptions}
                    name="industry"
                    title="Which industry do you work in?"
                    value={iraFormData.industry}
                    onChange={(e) => setIRAFormData({ ...iraFormData, industry: e?.value || "" })}
                    size={"large"}
                  />
                  <SearchableDropdown
                    options={occupationOptions}
                    name="occupation"
                    title="What's your occupation?"
                    value={iraFormData.occupation}
                    onChange={(e) => setIRAFormData({ ...iraFormData, occupation: e?.value || "" })}
                    size={"large"}
                  />
                </>
              )}
            </QuestionContainer>
          </FormSectionContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button
          name="continue"
          onClick={onClickContinue}
          disabled={!shouldContinue}
          size="large"
          isLoading={isButtonLoading}
        >
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};
export default IRAOpenForm;
